// Runs Dubb AI's OAuth connect in a hidden iframe once, on the dashboard load
// that follows a Dubb AI session bootstrap. The bootstrap page appends the
// connect URL to its dashboard redirect under this key (see
// components/dubb-ai/session-bootstrap.vue).
//
// The param is user-editable, so we validate it here before framing: it must be
// https and exactly the Dubb AI origin (window.Spark.dubbAiBaseUrl). It is
// best-effort: failures are silent and not retried; the user can always connect
// manually from the Dubb AI account page.
export const CONNECT_URL_QUERY_KEY = 'dubb_ai_connect_url'

export function frameDubbAiConnect() {
  const params = new URLSearchParams(window.location.search)
  const connectUrl = params.get(CONNECT_URL_QUERY_KEY)
  if (!connectUrl) {
    return
  }

  // Drop the param so it does not linger in the address bar or bookmarks.
  params.delete(CONNECT_URL_QUERY_KEY)
  const search = params.toString()
  window.history.replaceState(
    window.history.state,
    '',
    window.location.pathname + (search ? `?${search}` : '') + window.location.hash,
  )

  if (!isDubbAiOrigin(connectUrl)) {
    return
  }

  const iframe = document.createElement('iframe')
  iframe.setAttribute('aria-hidden', 'true')
  iframe.style.display = 'none'
  iframe.src = connectUrl
  document.body.appendChild(iframe)
}

// The bootstrap page's `connect_url` and `return_url` params are both
// user-editable, so each must be https and exactly the Dubb AI origin before
// it is framed or navigated to.
export function isDubbAiOrigin(rawUrl) {
  let url
  let base
  try {
    url = new URL(rawUrl)
    base = new URL(window.Spark?.dubbAiBaseUrl || 'https://ai.dubb.com')
  }
  catch {
    return false
  }

  return url.protocol === 'https:' && url.origin === base.origin
}
